import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  effect,
  inject,
  input,
  signal,
} from '@angular/core';
import { BdHelpService } from '../help.service';
import { BdHelpLink } from '../help.model';
import {
  BD_HELP_BUTTON_OPTIONS_DEFAULT,
  BdHelpButtonOptions,
} from './options.model';
import { ButtonDirective, ButtonIcon } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';

@Component({
  selector: 'bd-help-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (link()) {
      <a
        [href]="link().link"
        target="_blank"
        rel="noopener"
        pButton
        rounded
        text
        severity="secondary"
        [pTooltip]="$safeNavigationMigration(link()?.displayName)"
      >
        <i class="pi pi-question-circle" pButtonIcon></i>
      </a>
    }
  `,
  imports: [ButtonDirective, ButtonIcon, Tooltip],
})
export class BdHelpButtonComponent {
  readonly key = input<string>();
  readonly options = input<BdHelpButtonOptions>(BD_HELP_BUTTON_OPTIONS_DEFAULT);

  public readonly link = signal<BdHelpLink | undefined>(undefined);

  private readonly _helpService = inject(BdHelpService);
  private readonly _changeDetection = inject(ChangeDetectorRef);

  constructor() {
    effect(() => {
      const key = this.key();
      this._helpService.findByKey(key).then(
        (link) => {
          this.link.set(link);
          this._changeDetection.markForCheck();
        },
        () => this.link.set(undefined),
      );
    });
  }
}
